import algoliasearchV3 from 'algoliasearch-v3/dist/algoliasearch';

export const algoliaV3 =
  window.ENV_VARS.ALGOLIA_APP_ID && window.ALGOLIA_SEARCH_KEY
    ? algoliasearchV3(window.ENV_VARS.ALGOLIA_APP_ID, window.ALGOLIA_SEARCH_KEY)
    : null;
